import { NonTAMatchSet } from "model/Match/Set/MatchSet";
import { checkTypeExhausted } from "Utility";
import { getNumTeams, MatchTeams } from "model/Match/MatchTeams";
import { getRosterId } from "model/Roster/Roster";
import { RoundsBasedTracks } from "./RoundBased/RoundsBasedTracks";
import { H2HTrackBasedTracks } from "./H2H/H2HTrackBasedTracks";

interface Props {
  set: NonTAMatchSet;
  teams: MatchTeams;
  matchId: string;
  tournamentId: string;
}

export const MatchViewerTracks = ({
  set,
  teams,
  tournamentId,
  matchId,
}: Props) => {
  const numTeams = getNumTeams(teams);

  if (numTeams === 2) {
    const rosterOne = teams.rosters.at(0);
    const rosterTwo = teams.rosters.at(1);

    if (!rosterOne || !rosterTwo || getNumTeams(teams) > 2) {
      return <></>;
    }
    const rosterOneId = getRosterId(rosterOne);
    const rosterTwoId = getRosterId(rosterTwo);
    if (!rosterOneId || !rosterTwoId) {
      return <></>;
    }
    switch (set.type) {
      case "ForwardCupMode":
      case "ForwardCupModeLong":
      case "Knockout":
      case "ReverseCupMode":
      case "Rounds":
      case "RoundsKnockout":
        return <></>;
      case "Matchmaking":
      case "WorldTour":
        return (
          <H2HTrackBasedTracks
            set={set}
            rosterOneId={rosterOneId}
            rosterTwoId={rosterTwoId}
            matchId={matchId}
            tournamentId={tournamentId}
          />
        );
      default:
        return checkTypeExhausted(set);
    }
  }

  switch (set.type) {
    case "ForwardCupMode":
    case "ForwardCupModeLong":
    case "Knockout":
    case "Matchmaking":
    case "ReverseCupMode":
    case "Rounds":
    case "RoundsKnockout":
    case "WorldTour":
      return (
        <RoundsBasedTracks
          set={set}
          teams={teams}
          tournamentId={tournamentId}
        />
      );
    default:
      return checkTypeExhausted(set);
  }
};
